import { createRouter, createWebHistory } from 'vue-router'
import Store from '@/store/index.js'
import axios from 'axios';

const DisplayLayout = () => import('../views/DisplayLayout.vue')
const TopView = () => import('../views/TopView.vue')
const LoginView = () => import('../views/LoginView.vue')
const MyAccount = () => import('../views/userInfo/MyAccount.vue')
const AccountEdit = () => import('../views/userInfo/AccountEdit.vue')
const PasswordEdit = () => import('../views/userInfo/PasswordEdit.vue')
const ResendPassword = () => import('../views/ResendPassword.vue')
const BookmarksIndex = () => import('../views/bookmarks/BookmarksIndex.vue')
const CalendarView = () => import('../views/CalendarView.vue')
const UserList = () => import('../views/userList/UserList.vue')
const AddUser = () => import('../views/userList/AddUser.vue')
const ShowUser = () => import('../views/userList/ShowUser.vue')
const EditUser = () => import('../views/userList/EditUser.vue')
const AdminPasswordEdit = () => import('../views/userList/AdminPasswordEdit.vue')
const GlobalSearchIndex = () => import('../views/globalSearch/GlobalSearchIndex.vue')
const ArticlesIndex = () => import('../views/articles/ArticlesIndex.vue')
const ArticlesIndexAll = () => import('../views/articles/ArticlesIndexAll.vue')
const ArticlesShow = () => import('../views/articles/ArticlesShow.vue')
const ConstructionsIndex = () => import('../views/constructions/ConstructionsIndex.vue')
const ConstructionsShow = () => import('../views/constructions/ConstructionsShow.vue')
const ConsultantsIndex = () => import('../views/consultants/ConsultantsIndex.vue')
const ConsultantsShow = () => import('../views/consultants/ConsultantsShow.vue')
const ArchitecturesIndex = () => import('../views/architectures/ArchitecturesIndex.vue')
const ArchitecturesShow = () => import('../views/architectures/ArchitecturesShow.vue')
const ArchitbuildingsIndex = () => import('../views/architbuildings/ArchitbuildingsIndex.vue')
const ArchitbuildingsShow = () => import('../views/architbuildings/ArchitbuildingsShow.vue')
const ArchitstoresIndex = () => import('../views/architstores/ArchitstoresIndex.vue')
const ArchitstoresShow = () => import('../views/architstores/ArchitstoresShow.vue')
const ArchitfarmlandsIndex = () => import('../views/architfarmlands/ArchitfarmlandsIndex.vue')
const ArchitfarmlandsShow = () => import('../views/architfarmlands/ArchitfarmlandsShow.vue')
const ArchitlandsIndex = () => import('../views/architlands/ArchitlandsIndex.vue')
const ArchitlandsShow = () => import('../views/architlands/ArchitlandsShow.vue')
const ArchitdemolitionsIndex = () => import('../views/architdemolitions/ArchitdemolitionsIndex.vue')
const ArchitdemolitionsShow = () => import('../views/architdemolitions/ArchitdemolitionsShow.vue')
const AdminArticlesIndex = () => import('../views/adminArticles/AdminArticlesIndex.vue')
const AdminArticlesNew = () => import('../views/adminArticles/AdminArticlesNew.vue')
const AdminArticlesShow = () => import('../views/adminArticles/AdminArticlesShow.vue')
const AdminArticlesEdit = () => import('../views/adminArticles/AdminArticlesEdit.vue')
const AdminConstructionsIndex = () => import('../views/adminConstructions/AdminConstructionsIndex.vue')
const AdminConstructionsInput = () => import('../views/adminConstructions/input/AdminConstructionsInput.vue')
const AdminConstructionsInputEdit = () => import('../views/adminConstructions/input/AdminConstructionsInputEdit.vue')
const AdminConstructionsOutput = () => import('../views/adminConstructions/AdminConstructionsOutput.vue')
const AdminConstructionsOutputText = () => import('../views/adminConstructions/AdminConstructionsOutputText.vue')
const AdminConstructionsNew = () => import('../views/adminConstructions/AdminConstructionsNew.vue')
const AdminConstructionsEdit = () => import('../views/adminConstructions/AdminConstructionsEdit.vue')
const AdminConsultantsIndex = () => import('../views/adminConsultants/AdminConsultantsIndex.vue')
const AdminConsultantsInput = () => import('../views/adminConsultants/input/AdminConsultantsInput.vue')
const AdminConsultantsInputEdit = () => import('../views/adminConsultants/input/AdminConsultantsInputEdit.vue')
const AdminConsultantsOutput = () => import('../views/adminConsultants/AdminConsultantsOutput.vue')
const AdminConsultantsOutputText = () => import('../views/adminConsultants/AdminConsultantsOutputText.vue')
const AdminConsultantsNew = () => import('../views/adminConsultants/AdminConsultantsNew.vue')
const AdminConsultantsEdit = () => import('../views/adminConsultants/AdminConsultantsEdit.vue')
const AdminArchitecturesIndex = () => import('../views/adminArchitectures/AdminArchitecturesIndex.vue')
const AdminArchitecturesNew = () => import('../views/adminArchitectures/AdminArchitecturesNew.vue')
const AdminArchitecturesEdit = () => import('../views/adminArchitectures/AdminArchitecturesEdit.vue')
const AdminArchitbuildingsIndex = () => import('../views/adminArchitbuildings/AdminArchitbuildingsIndex.vue')
const AdminArchitbuildingsNew = () => import('../views/adminArchitbuildings/AdminArchitbuildingsNew.vue')
const AdminArchitbuildingsEdit = () => import('../views/adminArchitbuildings/AdminArchitbuildingsEdit.vue')
const AdminArchitstoresIndex = () => import('../views/adminArchitstores/AdminArchitstoresIndex.vue')
const AdminArchitstoresNew = () => import('../views/adminArchitstores/AdminArchitstoresNew.vue')
const AdminArchitstoresEdit = () => import('../views/adminArchitstores/AdminArchitstoresEdit.vue')
const AdminArchitfarmlandsIndex = () => import('../views/adminArchitfarmlands/AdminArchitfarmlandsIndex.vue')
const AdminArchitfarmlandsNew = () => import('../views/adminArchitfarmlands/AdminArchitfarmlandsNew.vue')
const AdminArchitfarmlandsEdit = () => import('../views/adminArchitfarmlands/AdminArchitfarmlandsEdit.vue')
const AdminArchitlandsIndex = () => import('../views/adminArchitlands/AdminArchitlandsIndex.vue')
const AdminArchitlandsNew = () => import('../views/adminArchitlands/AdminArchitlandsNew.vue')
const AdminArchitlandsEdit = () => import('../views/adminArchitlands/AdminArchitlandsEdit.vue')
const AdminArchitdemolitionsIndex = () => import('../views/adminArchitdemolitions/AdminArchitdemolitionsIndex.vue')
const AdminArchitdemolitionsNew = () => import('../views/adminArchitdemolitions/AdminArchitdemolitionsNew.vue')
const AdminArchitdemolitionsEdit = () => import('../views/adminArchitdemolitions/AdminArchitdemolitionsEdit.vue')
const AdminEditTopics = () => import('../views/adminEditTopics/AdminEditTopics.vue')
const AdminEditMessage = () => import('../views/adminEditMessage/AdminEditMessage.vue')
const AdminBannerAds = () => import('../views/adminBannerAds/AdminBannerAds.vue')
const AdminArchitoutxls = () => import('../views/adminArchitoutxls/AdminArchitoutxls.vue')
const AdminArchitStatsXls = () => import('../views/adminArchitStatsXls/AdminArchitStatsXls.vue')
const AdminOutputAccessLog = () => import('../views/adminOutputAccessLog/AdminOutputAccessLog.vue')
const IssuePassword = () => import('../views/IssuePassword.vue')
const AdminRemindersIndex = () => import('../views/adminReminders/AdminRemindersIndex.vue')
const RemindersIndex = () => import('../views/reminders/RemindersIndex.vue')
const RemindersAggregate = () => import('../views/remindersAggregate/RemindersAggregate.vue')
const NewsPaperView = () => import('../views/newsPaper/NewsPaperView.vue')
const AdminNewspapersIndex = () => import('../views/adminNewspapers/AdminNewspapersIndex.vue')
const AdminNewspapersNew = () => import('../views/adminNewspapers/AdminNewspapersNew.vue')
const AdminNewspapersEdit = () => import('../views/adminNewspapers/AdminNewspapersEdit.vue')

const routes = [
  {
    path: '/',
    component: DisplayLayout,
    children: [
      { path: '', name: 'topView', component: TopView, beforeEnter: beforeEnterGeneral },
      { path: '/login', name: 'loginView', component: LoginView, beforeEnter: beforeEnterLoginView },
      { path: '/resendpassword', name: 'resendPassword', component: ResendPassword, beforeEnter: beforeEnterLoginView },
      { path: '/bookmarks', name: 'bookmarksIndex', component: BookmarksIndex, beforeEnter: beforeEnterArticlesIndex },
      { path: '/calendar', name: 'calendarView', component: CalendarView, beforeEnter: beforeEnterArticlesIndex },
      { path: '/issuepassword/:code?', name: 'issuePassword', component: IssuePassword, beforeEnter: beforeEnterIssuePassword},
      {
        path: '/userlist',
        children: [
          { path: '', name: 'userList', component: UserList },
          { path: 'add', name: 'addUser', component: AddUser },
          { path: 'show/:id', name: 'showUser', component: ShowUser },
          { path: 'edit/:id', name: 'editUser', component: EditUser },
          { path: 'passwordedit/:id', name: 'adminPasswordEdit', component: AdminPasswordEdit },
        ],
        beforeEnter: beforeEnterAdminEx
      },
      {
        path: '/myaccount',
        children: [
          { path: '/myaccount', name: 'myaccount', component: MyAccount },
          { path: '/accountedit', name: 'accountedit', component: AccountEdit },
          { path: '/passwordedit', name: 'passwordedit', component: PasswordEdit },
        ],
        beforeEnter: beforeEnterArticlesIndex
      },
      {
        path: '/globalsearch',
        children: [
          { path: ':keyword?', name: 'globalSearchIndex', component: GlobalSearchIndex, beforeEnter: beforeEnterArticlesIndex },
        ]
      },
      {
        path: '/articles',
        children: [
          { path: '', name: 'articlesIndex', component: ArticlesIndex, beforeEnter: beforeEnterArticlesIndex },
          { path: 'all', name: 'articlesIndexAll', component: ArticlesIndexAll, beforeEnter: beforeEnterArticlesIndex },
          { path: ':id', name: 'articlesShow', component: ArticlesShow, beforeEnter: beforeEnterArticlesShow },
        ]
      },
      {
        path: '/constructions',
        children: [
          { path: '', name: 'constructionsIndex', component: ConstructionsIndex },
          { path: ':id', name: 'constructionsShow', component: ConstructionsShow, beforeEnter: beforeEnterConstructionsShow },
        ],
        beforeEnter: beforeEnterConstructions
      },
      {
        path: '/consultants',
        children: [
          { path: '', name: 'consultantsIndex', component: ConsultantsIndex },
          { path: ':id', name: 'consultantsShow', component: ConsultantsShow, beforeEnter: beforeEnterConsultantsShow },
        ],
        beforeEnter: beforeEnterConsultants
      },
      {
        path: '/architectures',
        children: [
          { path: '', name: 'architecturesIndex', component: ArchitecturesIndex, beforeEnter: beforeEnterArchitectures },
          { path: ':id', name: 'architecturesShow', component: ArchitecturesShow, beforeEnter: beforeEnterArchitectures },
        ]
      },
      {
        path: '/architbuildings',
        children: [
          { path: '', name: 'architbuildingsIndex', component: ArchitbuildingsIndex, beforeEnter: beforeEnterArchitectures },
          { path: ':id', name: 'architbuildingsShow', component: ArchitbuildingsShow, beforeEnter: beforeEnterArchitectures },
        ]
      },
      {
        path: '/architstores',
        children: [
          { path: '', name: 'architstoresIndex', component: ArchitstoresIndex, beforeEnter: beforeEnterArchitectures },
          { path: ':id', name: 'architstoresShow', component: ArchitstoresShow, beforeEnter: beforeEnterArchitectures },
        ]
      },
      {
        path: '/architfarmlands',
        children: [
          { path: '', name: 'architfarmlandsIndex', component: ArchitfarmlandsIndex, beforeEnter: beforeEnterArchitectures },
          { path: ':id', name: 'architfarmlandsShow', component: ArchitfarmlandsShow, beforeEnter: beforeEnterArchitectures },
        ]
      },
      {
        path: '/architlands',
        children: [
          { path: '', name: 'architlandsIndex', component: ArchitlandsIndex, beforeEnter: beforeEnterArchitectures },
          { path: ':id', name: 'architlandsShow', component: ArchitlandsShow, beforeEnter: beforeEnterArchitectures },
        ]
      },
      {
        path: '/architdemolitions',
        children: [
          { path: '', name: 'architdemolitionsIndex', component: ArchitdemolitionsIndex, beforeEnter: beforeEnterArchitectures },
          { path: ':id', name: 'architdemolitionsShow', component: ArchitdemolitionsShow, beforeEnter: beforeEnterArchitectures },
        ]
      },
      {
        path: '/admin-articles',
        children: [
          { path: '', name: 'adminArticlesIndex', component: AdminArticlesIndex },
          { path: 'new', name: 'adminArticlesNew', component: AdminArticlesNew },
          { path: ':id', name: 'adminArticlesShow', component: AdminArticlesShow, beforeEnter: beforeEnterAdminArticlesShow },
          { path: 'edit/:id', name: 'adminArticlesEdit', component: AdminArticlesEdit, beforeEnter: beforeEnterAdminArticlesEdit },
        ],
        beforeEnter: beforeEnterAdmin
      },
      {
        path: '/admin-constructions',
        children: [
          { path: '', name: 'adminConstructionsIndex', component: AdminConstructionsIndex },
          { path: 'input_data', name: 'adminConstructionsInput', component: AdminConstructionsInput },
          { path: 'input_data/:id', name: 'adminConstructionsInputEdit', component: AdminConstructionsInputEdit , beforeEnter: beforeEnterAdminConstructionsInputEdit },
          { path: 'output_data/:id', name: 'adminConstructionsOutput', component: AdminConstructionsOutput, props: true },
          { path: 'output_text/:id', name: 'adminConstructionsOutputText', component: AdminConstructionsOutputText, props: true },
          { path: 'new', name: 'adminConstructionsNew', component: AdminConstructionsNew },
          { path: 'edit/:id', name: 'adminConstructionsEdit', component: AdminConstructionsEdit, beforeEnter: beforeEnterAdminConstructionsEdit },
        ],
        beforeEnter: beforeEnterAdmin
      },
      {
        path: '/admin-consultants',
        children: [
          { path: '', name: 'adminConsultantsIndex', component: AdminConsultantsIndex },
          { path: 'input_data', name: 'adminConsultantsInput', component: AdminConsultantsInput },
          { path: 'input_data/:id', name: 'adminConsultantsInputEdit', component: AdminConsultantsInputEdit, beforeEnter: beforeEnterAdminConsultantsInputEdit },
          { path: 'output_data/:id', name: 'adminConsultantsOutput', component: AdminConsultantsOutput, props: true },
          { path: 'output_text/:id', name: 'adminConsultantsOutputText', component: AdminConsultantsOutputText, props: true },
          { path: 'new', name: 'adminConsultantsNew', component: AdminConsultantsNew },
          { path: 'edit/:id', name: 'adminConsultantsEdit', component: AdminConsultantsEdit, beforeEnter: beforeEnterAdminConsultantsEdit },
        ],
        beforeEnter: beforeEnterAdmin
      },
      {
        path: '/admin-architectures',
        children: [
          { path: '', name: 'adminArchitecturesIndex', component: AdminArchitecturesIndex },
          { path: 'new', name: 'adminArchitecturesNew', component: AdminArchitecturesNew },
          { path: 'edit/:id', name: 'adminArchitecturesEdit', component: AdminArchitecturesEdit, beforeEnter: beforeEnterAdminArchitecturesEdit },
        ],
        beforeEnter: beforeEnterAdmin
      },
      {
        path: '/admin-architbuildings',
        children: [
          { path: '', name: 'adminArchitbuildingsIndex', component: AdminArchitbuildingsIndex },
          { path: 'new', name: 'adminArchitbuildingsNew', component: AdminArchitbuildingsNew },
          { path: 'edit/:id', name: 'adminArchitbuildingsEdit', component: AdminArchitbuildingsEdit, beforeEnter: beforeEnterAdminArchitbuildingsEdit },
        ],
        beforeEnter: beforeEnterAdmin
      },
      {
        path: '/admin-architstores',
        children: [
          { path: '', name: 'adminArchitstoresIndex', component: AdminArchitstoresIndex },
          { path: 'new', name: 'adminArchitstoresNew', component: AdminArchitstoresNew },
          { path: 'edit/:id', name: 'adminArchitstoresEdit', component: AdminArchitstoresEdit, beforeEnter: beforeEnterAdminArchitstoresEdit },
        ],
        beforeEnter: beforeEnterAdmin
      },
      {
        path: '/admin-architfarmlands',
        children: [
          { path: '', name: 'adminArchitfarmlandsIndex', component: AdminArchitfarmlandsIndex },
          { path: 'new', name: 'adminArchitfarmlandsNew', component: AdminArchitfarmlandsNew },
          { path: 'edit/:id', name: 'adminArchitfarmlandsEdit', component: AdminArchitfarmlandsEdit, beforeEnter: beforeEnterAdminArchitfarmlandsEdit },
        ],
        beforeEnter: beforeEnterAdmin
      },
      {
        path: '/admin-architlands',
        children: [
          { path: '', name: 'adminArchitlandsIndex', component: AdminArchitlandsIndex },
          { path: 'new', name: 'adminArchitlandsNew', component: AdminArchitlandsNew },
          { path: 'edit/:id', name: 'adminArchitlandsEdit', component: AdminArchitlandsEdit, beforeEnter: beforeEnterAdminArchitlandsEdit },
        ],
        beforeEnter: beforeEnterAdmin
      },
      {
        path: '/admin-architdemolitions',
        children: [
          { path: '', name: 'adminArchitdemolitionsIndex', component: AdminArchitdemolitionsIndex },
          { path: 'new', name: 'adminArchitdemolitionsNew', component: AdminArchitdemolitionsNew },
          { path: 'edit/:id', name: 'adminArchitdemolitionsEdit', component: AdminArchitdemolitionsEdit, beforeEnter: beforeEnterAdminArchitdemolitionsEdit },
        ],
        beforeEnter: beforeEnterAdmin
      },
      {
        path: '/admin-edit-topics',
        children: [
          { path: '', name: 'adminEditTopics', component: AdminEditTopics, beforeEnter: beforeEnterAdmin },
        ]
      },
      {
        path: '/admin-edit-message',
        children: [
          { path: '', name: 'adminEditMessage', component: AdminEditMessage, beforeEnter: beforeEnterAdmin },
        ]
      },
      {
        path: '/admin-banner-ads',
        children: [
          { path: '', name: 'adminBannerAds', component: AdminBannerAds, beforeEnter: beforeEnterAdmin },
        ]
      },
      {
        path: '/admin-architoutxls',
        children: [
          { path: '', name: 'adminArchitoutxls', component: AdminArchitoutxls, beforeEnter: beforeEnterAdmin },
        ]
      },
      {
        path: '/admin-architstatsxls',
        children: [
          { path: '', name: 'adminArchitStatsXls', component: AdminArchitStatsXls, beforeEnter: beforeEnterAdmin },
        ]
      },
      {
        path: '/admin-output-accesslog',
        children: [
          { path: '', name: 'adminOutputAccessLog', component: AdminOutputAccessLog, beforeEnter: beforeEnterAdmin },
        ]
      },
      {
        path: '/admin-reminders',
        children: [
          { path: '', name: 'adminRemindersIndex', component: AdminRemindersIndex },
        ],
        beforeEnter: beforeEnterAdmin
      },
      {
        path: '/reminders',
        children: [
          { path: '', name: 'remindersIndex', component: RemindersIndex }
        ],
        beforeEnter: beforeEnterArticlesIndex
      },
      {
        path: '/reminders-aggregate',
        children: [
          { path: '', name: 'remindersAggregate', component: RemindersAggregate }
        ],
        beforeEnter: beforeEnterArticlesIndex
      },
      {
        path: '/newspaperview',
        children: [
          { path: '', name: 'NewsPaperView', component: NewsPaperView }
        ],
        beforeEnter: beforeEnterArticlesIndex
      },
      {
        path: '/admin-newspapers',
        children: [
          { path: '', name: 'adminNewspapersIndex', component: AdminNewspapersIndex },
          { path: 'new', name: 'adminNewspapersNew', component: AdminNewspapersNew },
          { path: 'edit/:id', name: 'adminNewspapersEdit', component: AdminNewspapersEdit, beforeEnter: beforeEnterAdminNewspapersEdit },
        ],
        beforeEnter: beforeEnterAdmin
      },
    ]
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

const publicPath = process.env.BASE_URL;

function loginRequired(next) {
  next(false);

  router.push({
    name: 'loginView'
  }).then(() => {
    Store.dispatch({
      type: 'setAlert',
      alert: {
        message: 'ログインしてください。',
        style: 'primary'
      }
    });
  });
}

function authorityRequired(next) {
  next(false);

  router.push({
    name: 'topView'
  }).then(() => {
    Store.dispatch({
      type: 'setAlert',
      alert: {
        message: 'この機能を利用する権限がありません。',
        style: 'warning'
      }
    });

    window.scrollTo(0, 0);
  });
}

// ログイン画面の遷移権限の処理
function beforeEnterLoginView(to, from, next) {
  // ログイン状態の更新
  Store.dispatch({ type: 'refreshUser' }).then(() => {
    if (Store.state.user !== null) {
      next(false);

      router.push({
        name: 'topView'
      }).then(() => {
        Store.dispatch({
          type: 'setAlert',
          alert: {
            message: 'ログイン済みです。',
            style: 'warning'
          }
        });
      });
    } else {
      next();
    }
  });
}

// 記事検索画面の遷移権限の処理
function beforeEnterArticlesIndex(to, from, next) {
  // ログイン状態の更新
  Store.dispatch({ type: 'refreshUser' }).then(() => {
    if (Store.state.user === null) {
      loginRequired(next);
    } else if (
      Store.state.user.admin === '0' ||
      Store.state.user.admin === '1' ||
      Store.state.user.admin === '2' ||
      Store.state.user.admin === '3' ||
      Store.state.user.admin === '4' ||
      Store.state.user.admin === '5'
    ) {
      next();
    } else {
      authorityRequired(next);
    }
  });
}

// 記事詳細画面の遷移権限の処理
function beforeEnterArticlesShow(to, from, next) {
  const url = publicPath + 'api/articles/forPublic';
  const params = { 'id': to.params.id };

  // ログイン状態の更新
  Store.dispatch({ type: 'refreshUser' }).then(() => {
    axios.post(url, params).then((res) => {
      if (
        (Store.state.user === null && res.data.forPublic !== '1')
        || !['1', '2'].includes(res.data.forPublic)
      ) {
        next(false);

        router.push({
          name: 'topView'
        }).then(() => {
          Store.dispatch({
            type: 'setAlert',
            alert: {
              message: '記事は見つかりませんでした。',
              style: 'danger'
            }
          });

          window.scrollTo(0, 0);
        });
      } else {
        next();
      }
    });
  });
}

// 工事入札検索画面の遷移権限の処理
function beforeEnterConstructions(to, from, next) {
  // ログイン状態の更新
  Store.dispatch({ type: 'refreshUser' }).then(() => {
    if (Store.state.user === null) {
      loginRequired(next);
    } else if (
      Store.state.user.admin === '0' ||
      Store.state.user.admin === '1' ||
      Store.state.user.admin === '2' ||
      Store.state.user.admin === '3'
    ) {
      next();
    } else {
      authorityRequired(next);
    }
  });
}

// コンサル入札検索画面の遷移権限の処理
function beforeEnterConsultants(to, from, next) {
  // ログイン状態の更新
  Store.dispatch({ type: 'refreshUser' }).then(() => {
    if (Store.state.user === null) {
      loginRequired(next);
    } else if (
      Store.state.user.admin === '0' ||
      Store.state.user.admin === '1' ||
      Store.state.user.admin === '2' ||
      Store.state.user.admin === '4'
    ) {
      next();
    } else {
      authorityRequired(next);
    }
  });
}

// みんかん系の検索画面の遷移権限の処理
function beforeEnterArchitectures(to, from, next) {
  // ログイン状態の更新
  Store.dispatch({ type: 'refreshUser' }).then(() => {
    if (Store.state.user === null) {
      loginRequired(next);
    } else if (
      Store.state.user.admin === '0' ||
      Store.state.user.admin === '1' ||
      Store.state.user.admin === '2' ||
      Store.state.user.admin === '5'
    ) {
      next();
    } else {
      authorityRequired(next);
    }
  });
}

// 管理画面系の遷移権限の処理
function beforeEnterAdmin(to, from, next) {
  // ログイン状態の更新
  Store.dispatch({ type: 'refreshUser' }).then(() => {
    if (Store.state.user === null) {
      loginRequired(next);
    } else if (
      Store.state.user.admin === '0' ||
      Store.state.user.admin === '1'
    ) {
      next();
    } else {
      next({ name: 'topView' });
    }
  });
}

// 管理画面系の遷移権限の処理
function beforeEnterAdminEx(to, from, next) {
  // ログイン状態の更新
  Store.dispatch({ type: 'refreshUser' }).then(() => {
    if (Store.state.user === null) {
      loginRequired(next);
    } else if (
      Store.state.user.admin === '0'
    ) {
      next();
    } else {
      authorityRequired(next);
    }
  });
}

// ログインが関係無い画面の処理
function beforeEnterGeneral(to, from, next) {
  // ログイン状態の更新
  Store.dispatch({ type: 'refreshUser' }).then(() => {
    next();
  });
}

// URLのIDに合致するデータが無い場合の処理
function dataDoesntExist(redirectName, message, next) {
  next(false);

  router.push({
    name: redirectName
  }).then(() => {
    Store.dispatch({
      type: 'setAlert',
      alert: {
        message: message,
        style: 'danger'
      }
    });
  });
}

function beforeEnterConstructionsShow(to, from, next) {
  const url = publicPath + 'api/constructions/exists';

  const params = { 'id': to.params.id };

  axios.post(url, params).then((res) => {
    if (res.data.exists === false) {
      dataDoesntExist('constructionsIndex', '指定された工事入札は存在しません。', next)
    } else {
      next();
    }
  });
}

function beforeEnterConsultantsShow(to, from, next) {
  const url = publicPath + 'api/consultants/exists';

  const params = { 'id': to.params.id };

  axios.post(url, params).then((res) => {
    if (res.data.exists === false) {
      dataDoesntExist('consultantsIndex', '指定されたコンサル入札は存在しません。', next)
    } else {
      next();
    }
  });
}

function beforeEnterAdminArticlesShow(to, from, next) {
  const url = publicPath + 'api/articles/exists';

  const params = { 'id': to.params.id };

  axios.post(url, params).then((res) => {
    if (res.data.exists === false) {
      dataDoesntExist('adminArticlesIndex', '指定された記事は存在しません。', next)
    } else {
      next();
    }
  });
}

function beforeEnterAdminArticlesEdit(to, from, next) {
  const url = publicPath + 'api/articles/exists';

  const params = { 'id': to.params.id };

  axios.post(url, params).then((res) => {
    if (res.data.exists === false) {
      dataDoesntExist('adminArticlesIndex', '指定された記事は存在しません。', next)
    } else {
      next();
    }
  });
}

function beforeEnterAdminConstructionsEdit(to, from, next) {
  const url = publicPath + 'api/constructions/exists';

  const params = { 'id': to.params.id };

  axios.post(url, params).then((res) => {
    if (res.data.exists === false) {
      dataDoesntExist('adminConstructionsIndex', '指定された工事入札は存在しません。', next)
    } else {
      next();
    }
  });
}

function beforeEnterAdminConstructionsInputEdit(to, from, next) {
  const url = publicPath + 'api/workconstructions/exists';

  const params = { 'id': to.params.id };

  axios.post(url, params).then((res) => {
    if (res.data.exists === false) {
      dataDoesntExist('adminConstructionsInput', '指定された工事入札は存在しません。', next)
    } else {
      next();
    }
  });
}

function beforeEnterAdminConsultantsEdit(to, from, next) {
  const url = publicPath + 'api/consultants/exists';

  const params = { 'id': to.params.id };

  axios.post(url, params).then((res) => {
    if (res.data.exists === false) {
      dataDoesntExist('adminConsultantsIndex', '指定されたコンサル入札は存在しません。', next)
    } else {
      next();
    }
  });
}

function beforeEnterAdminConsultantsInputEdit(to, from, next) {
  const url = publicPath + 'api/workconsultants/exists';

  const params = { 'id': to.params.id };

  axios.post(url, params).then((res) => {
    if (res.data.exists === false) {
      dataDoesntExist('adminConsultantsInput', '指定されたコンサル入札は存在しません。', next)
    } else {
      next();
    }
  });
}

function beforeEnterAdminArchitecturesEdit(to, from, next) {
  const url = publicPath + 'api/architectures/exists';

  const params = { 'id': to.params.id };

  axios.post(url, params).then((res) => {
    if (res.data.exists === false) {
      dataDoesntExist('adminArchitecturesIndex', '指定された建築確認申請は存在しません。', next)
    } else {
      next();
    }
  });
}

function beforeEnterAdminArchitbuildingsEdit(to, from, next) {
  const url = publicPath + 'api/architbuildings/exists';

  const params = { 'id': to.params.id };

  axios.post(url, params).then((res) => {
    if (res.data.exists === false) {
      dataDoesntExist('adminArchitbuildingsIndex', '指定された中高層建築は存在しません。', next)
    } else {
      next();
    }
  });
}

function beforeEnterAdminArchitstoresEdit(to, from, next) {
  const url = publicPath + 'api/architstores/exists';

  const params = { 'id': to.params.id };

  axios.post(url, params).then((res) => {
    if (res.data.exists === false) {
      dataDoesntExist('adminArchitstoresIndex', '指定された大型店舗新設は存在しません。', next)
    } else {
      next();
    }
  });
}

function beforeEnterAdminArchitfarmlandsEdit(to, from, next) {
  const url = publicPath + 'api/architfarmlands/exists';

  const params = { 'id': to.params.id };

  axios.post(url, params).then((res) => {
    if (res.data.exists === false) {
      dataDoesntExist('adminArchitfarmlandsIndex', '指定された農地転用は存在しません。', next)
    } else {
      next();
    }
  });
}

function beforeEnterAdminArchitlandsEdit(to, from, next) {
  const url = publicPath + 'api/architlands/exists';

  const params = { 'id': to.params.id };

  axios.post(url, params).then((res) => {
    if (res.data.exists === false) {
      dataDoesntExist('adminArchitlandsIndex', '指定された土地開発は存在しません。', next)
    } else {
      next();
    }
  });
}

function beforeEnterAdminArchitdemolitionsEdit(to, from, next) {
  const url = publicPath + 'api/architdemolitions/exists';

  const params = { 'id': to.params.id };

  axios.post(url, params).then((res) => {
    if (res.data.exists === false) {
      dataDoesntExist('adminArchitdemolitionsIndex', '指定された解体工事は存在しません。', next)
    } else {
      next();
    }
  });
}

function beforeEnterAdminNewspapersEdit(to, from, next) {
  const url = publicPath + 'api/newspapers/exists';

  const params = { 'id': to.params.id };

  axios.post(url, params).then((res) => {
    if (res.data.exists === false) {
      dataDoesntExist('adminNewspapersIndex', '指定された紙面は存在しません。', next)
    } else {
      next();
    }
  });
}

function PasswordAuthorityRequired(next, message) {
  next(false);

  router.push({
    name: 'topView'
  }).then(() => {
    Store.dispatch({
      type: 'setAlert',
      alert: {
        message: message,
        style: 'warning'
      }
    });

    window.scrollTo(0, 0);
  });
}

function beforeEnterIssuePassword(to, from, next) {
  const url = publicPath + 'api/issuepassword/check';

  const params = { 'code': to.params.code };

  axios.post(url, params).then((res) => {
    if (res.data.exists === 0) {
      next();
    } else if(res.data.exists === 1) {
      PasswordAuthorityRequired(next, "認証されていません。");
    } else if(res.data.exists === 2) {
      PasswordAuthorityRequired(next, "リンクの有効期限が切れています。");
    }
  });
}

export default router
